"use strict";
/**
 * Base primitives and interfaces for Stateful Infrastructure Resources in man-core.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseResource = void 0;
class BaseResource {
    name;
    _isActive = false;
    constructor(name) {
        this.name = name;
    }
    get isActive() {
        return this._isActive;
    }
    async start() {
        this._isActive = true;
    }
    async stop() {
        this._isActive = false;
    }
    healthCheck() {
        return {
            resource: this.name,
            status: this._isActive ? 'healthy' : 'stopped',
        };
    }
}
exports.BaseResource = BaseResource;
